export const RESTAURANT = [
  {
    label: "Rooms",
    title: "Affordable Sanctuaries: Unveiling Our Rooms in Baga",
    desc: "Step into a world of opulence and comfort at our guesthouse in Baga, Goa. Our meticulously designed rooms are a symphony of elegance and relaxation, offering you a haven to unwind and rejuvenate.",
    img: "/images/placeholder-rect.png"
  },
  {
    label: "Hospitality",
    title: "True Goan Hospitality: Where Guests Become Family",
    desc: "At our guesthouse, we take pride in offering you an authentic taste of Goan hospitality. From the moment you step foot on our premises, you become a part of our extended family.",
    img: "/images/placeholder-rect.png"
  },
  {
    label: "Leisure",
    title: "Immerse Yourself in Knowledge: The Mini Library Retreat",
    desc: "For those seeking solace in the pages of a book, our mini library is a tranquil haven waiting to be explored. Nestled within our guesthouse, this cozy corner is a treasure trove of literary wonders",
    img: "/images/placeholder-rect.png"
  },
  {
    label: "Around us",
    title: "Embrace the Goa Pulse: Events Unveiled",
    desc: "Immerse yourself in the vibrant tapestry of Goa's cultural landscape with our guide to the hottest events happening around Baga. From electrifying music festivals to bustling night markets, we bring you closer to the heart of Goa's vibrant scene.",
    img: "/images/placeholder-rect.png"
  },
]